import { BookOpenText, Square, X } from "lucide-react";

// MiLu's words on screen while she reads them out.
export const ReadAlong = ({ speaker }) => {
  const said = speaker.said;
  if (!said || (!speaker.playing && !speaker.loading)) return null;

  return (
    <aside
      data-testid="read-along"
      className="fixed bottom-4 start-4 z-40 w-[min(28rem,calc(100vw-2rem))] rounded-3xl border border-brand/30 bg-page/95 p-4 shadow-2xl backdrop-blur-xl"
    >
      <div className="flex items-center gap-2">
        <p className="flex min-w-0 items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-brand">
          <BookOpenText className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate" data-testid="read-along-label">{said.label || "Reading along"}</span>
        </p>
        <button
          data-testid="read-along-stop"
          onClick={speaker.stop}
          aria-label="Stop reading"
          className="ms-auto inline-flex items-center gap-1 rounded-full border border-white/15 px-2.5 py-1 text-[11px] text-ink-soft transition-colors hover:border-brand/50 hover:text-brand"
        >
          <Square className="h-3 w-3" /> Stop
        </button>
        <button
          data-testid="read-along-close"
          onClick={speaker.stop}
          aria-label="Close read along"
          className="text-ink-soft/70 hover:text-ink"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>

      <div className="mt-2 max-h-[46vh] space-y-2 overflow-y-auto pe-1 text-sm leading-relaxed"
           data-testid="read-along-text" dir="auto">
        {said.text
          ? said.text.split(/\n+/).filter(Boolean).map((para, i) => <p key={i}>{para}</p>)
          : <p className="text-ink-soft">MiLu is reading the whole story — this takes a few seconds…</p>}
      </div>
    </aside>
  );
};
